'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAVORITE_SET_ITEMS = exports.FAVORITE_REMOVE = exports.FAVORITE_ADD = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.favoriteItem = favoriteItem;
exports.favoriteItemUpload = favoriteItemUpload;
exports.removeFavoriteItem = removeFavoriteItem;
exports.fetchFavorites = fetchFavorites;
exports.fetchFavoritesIfNeeded = fetchFavoritesIfNeeded;

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _lodash = require('lodash');

var _actions = require('../User/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAVORITE_ADD = exports.FAVORITE_ADD = 'FAVORITE_ADD';
var FAVORITE_REMOVE = exports.FAVORITE_REMOVE = 'FAVORITE_REMOVE';
var FAVORITE_SET_ITEMS = exports.FAVORITE_SET_ITEMS = 'FAVORITE_SET_ITEMS';

var API_URL = 'https://api.mybuildercloud.com/api/v2/favorites';
/**
 * @typedef {Object} FavoriteItem
 * @property {string} favoriteId
 * @property {string} title
 * @property {Array<number>} location // Geo Index [Latitude, Longitude]
 * @property {string} relativePath
 * @property {string} image
 * @property {string} type
 * @property {string} favoritedAt
 */

/**
 * Favorite a single item. Performs request to favorites API for persistence.
 * If the request results in a 401 error the user is logged out and the favorite item is dispatched
 * to be added to local storage.
 *
 * Override API location with the global config `apis.favorites`
 *
 * @param {FavoriteItem} item single favorite item
 * @returns
 */
function favoriteItem(item) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var builderId, _getState, token, _ref2, favorite;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              builderId = _bdcoreUtilities.ConfigStore.getConfig('builder_id');
              _getState = getState(), token = _getState.user.token;


              dispatch({
                type: FAVORITE_ADD,
                item: item
              });

              _bdcoreUtilities.GlobalEvents.emit('Favorites::favoriteItem', { item: item });

              if (!token) {
                _context.next = 16;
                break;
              }

              _context.prev = 5;
              _context.next = 8;
              return (0, _axios2.default)({
                headers: {
                  Authorization: 'Bearer ' + token
                },
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.favorites', API_URL) + '/item',
                method: 'POST',
                data: {
                  builder: builderId,
                  item: item
                }
              });

            case 8:
              _ref2 = _context.sent;
              favorite = _ref2.data;


              dispatch({
                type: FAVORITE_ADD,
                item: favorite
              });
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](5);

              if ((0, _lodash.get)(_context.t0, 'response.status') === 401) {
                dispatch({
                  type: _actions.USER_LOGOUT
                });
                dispatch({
                  type: FAVORITE_ADD,
                  item: item
                });
              } else {
                dispatch({
                  type: FAVORITE_REMOVE,
                  favoriteId: item.favoriteId
                });
              }

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[5, 13]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}
function favoriteItemUpload(item, file) {
  var _this2 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var builderId, _getState2, token, formData, _ref4, favorite;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              builderId = _bdcoreUtilities.ConfigStore.getConfig('builder_id');
              _getState2 = getState(), token = _getState2.user.token;

              if (!token) {
                _context2.next = 18;
                break;
              }

              formData = new FormData();

              formData.append('file', file);
              formData.append('builder', builderId);
              formData.append('item', (0, _stringify2.default)(item));

              _context2.prev = 7;
              _context2.next = 10;
              return (0, _axios2.default)({
                headers: {
                  Authorization: 'Bearer ' + token
                },
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.favorites', API_URL) + '/item/upload',
                method: 'POST',
                data: formData
              });

            case 10:
              _ref4 = _context2.sent;
              favorite = _ref4.data;


              dispatch({
                type: FAVORITE_ADD,
                item: favorite
              });
              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2['catch'](7);

              dispatch({
                type: FAVORITE_REMOVE,
                favoriteId: item.favoriteId
              });

            case 18:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[7, 15]]);
    }));

    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function removeFavoriteItem(item) {
  var _this3 = this;

  var favoriteId = item.favoriteId;

  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var _getState3, token, builderId;

      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _getState3 = getState(), token = _getState3.user.token;
              builderId = _bdcoreUtilities.ConfigStore.getConfig('builder_id');


              dispatch({
                type: FAVORITE_REMOVE,
                favoriteId: favoriteId
              });

              _bdcoreUtilities.GlobalEvents.emit('Favorites::unfavoriteItem', { item: item });

              if (!token) {
                _context3.next = 13;
                break;
              }

              _context3.prev = 5;
              _context3.next = 8;
              return (0, _axios2.default)({
                headers: {
                  Authorization: 'Bearer ' + token
                },
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.favorites', API_URL) + '/item',
                method: 'DELETE',
                data: {
                  builder: builderId,
                  item: item
                }
              });

            case 8:
              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](5);

              if ((0, _lodash.get)(_context3.t0, 'response.status') === 401) {
                dispatch({
                  type: _actions.USER_LOGOUT
                });
              } else {
                dispatch({
                  type: FAVORITE_ADD,
                  item: item
                });
              }

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[5, 10]]);
    }));

    return function (_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }();
}

function fetchFavorites() {
  var _this4 = this;

  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
      var _getState4, token, _getState4$favorites$, items, builderId, _ref7, _ref7$data$items, savedItems;

      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // Skip if product not enabled
              _getState4 = getState(), token = _getState4.user.token, _getState4$favorites$ = _getState4.favorites.items, items = _getState4$favorites$ === undefined ? [] : _getState4$favorites$;

              if (token) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt('return');

            case 3:
              builderId = _bdcoreUtilities.ConfigStore.getConfig('builder_id');
              _context4.prev = 4;
              _context4.next = 7;
              return (0, _axios2.default)({
                headers: {
                  Authorization: 'Bearer ' + token
                },
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.favorites', API_URL) + '/connect',
                method: 'POST',
                data: {
                  builder: builderId,
                  items: items
                }
              });

            case 7:
              _ref7 = _context4.sent;
              _ref7$data$items = _ref7.data.items;
              savedItems = _ref7$data$items === undefined ? [] : _ref7$data$items;


              dispatch({
                type: FAVORITE_SET_ITEMS,
                items: savedItems,
                fetched: true
              });
              _context4.next = 16;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4['catch'](4);

              console.error('Error getting favorites', _context4.t0);

            case 16:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[4, 13]]);
    }));

    return function (_x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }();
}

function shouldFetchFavorites(_ref8) {
  var favorites = _ref8.favorites,
      token = _ref8.user.token;
  var fetched = favorites.fetched;


  if (!fetched && token) {
    return true;
  } else if (favorites.isFetching) {
    return false;
  }

  return favorites.didInvalidate;
}

function fetchFavoritesIfNeeded() {
  return function (dispatch, getState) {
    if (shouldFetchFavorites(getState())) {
      return dispatch(fetchFavorites());
    }
    return null;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Favorites/actions.js
// module id = 527
// module chunks = 0